export default theme => ({

  root: {
    position: "sticky",
    top: 0,
    left: 0,
    right: 0,
    height: 120,
    backgroundColor: "#FFF",
    zIndex: 100
  },

  rootiOS:{
    position: "sticky",
    top: 0,
    left: 0,
    right: 0,
    height: 120,
    backgroundColor: "#FFF",
    zIndex: 100,
    paddingTop: `constant(safe-area-inset-top)`,
    paddingLeft: `constant(safe-area-inset-left)`,
    paddingRight: `constant(safe-area-inset-right)`,
    paddingTop: `env(safe-area-inset-top)`,
    paddingLeft: `env(safe-area-inset-left)`,
    paddingRight: `env(safe-area-inset-right)`
  },

  list: {
    width: "auto"
  },
  
  logo: {
    position: "absolute",
    left: 18,
    /* top: 25, */
    height: 130,
    width: 155
  },

  button: {
    padding: 0,
    [theme.breakpoints.down("xs")]: {
      marginLeft: 160
    },
    [theme.breakpoints.up("xs")]: {
      marginLeft: 285
    },
    [theme.breakpoints.up("sm")]: {
      marginLeft: 475
    },
    [theme.breakpoints.up("md")]: {
      marginLeft: 725
    },
    marginTop: -5
  },
  paper: {
    paddingTop: 15,
    paddingBottom: 15,
    paddingLeft: 25,
    marginTop: -10
  },
  paperiOS:{
    paddingTop: `constant(safe-area-inset-top)`,
    paddingTop: `env(safe-area-inset-top)`,
    paddingBottom: 15,
    paddingLeft: 25,
    marginTop: -10
  },
  expansionList: {
    width: "100%",
    paddingLeft: theme.breakpoints.down("sm") ? 50 : 500
  },
  divider: {
    width: "100%",
    height: "2px"
  },
  itemPaper: {
    paddingTop: 15,
    paddingBottom: 15,
    paddingLeft: 25
  },
  title: {
    color: "#808080",
    fontWeight: "bold",
    fontSize: 18,
    [theme.breakpoints.up("xs")]: {
      paddingRight: 160
    },
    [theme.breakpoints.up("sm")]: {
      paddingRight: 350
    },
    [theme.breakpoints.up("md")]: {
      paddingRight: 600
    }
  },
  title2: {
    color: "#808080",
    fontWeight: "bold",
    fontSize: 18,
    marginLeft: "-8px",
    [theme.breakpoints.up("xs")]: {
      paddingRight: 160
    },
    [theme.breakpoints.up("sm")]: {
      paddingRight: 350
    },
    [theme.breakpoints.up("md")]: {
      paddingRight: 600
    }
  },
  link: {
    color: "#808080",
    fontWeight: "bold",
    fontSize: 16
  },

  eccoLogo: {
    position: "relative",
    bottom: 20
  },
  crossIcon: {
    // marginLeft: "15px",
    // // padding: "2px 0",
    // "& img": {
    //   width: 26,
    //   height: 30,
    //   "&:nth-child(1)": {
    //     paddingRight: theme.spacing(["5", 2])
    //   }
    // },
    [theme.breakpoints.down("xs")]: {
      zIndex: -1,
      position: "fixed",
      overflow: "hidden",
      top: "100%",
      marginTop: "-100px",
      marginLeft: "15px",
      textAlign: "left",
    }
  },
  textRedes: {
    marginBottom: "10px",
    textAlign: "left",
    fontSize: 15,
    color: "#797979"
  },
  
});
